import view from './view.js';

export { view};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_export/question_export/index.js